/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2022-02-09 13:52:09
 */
// const enterpriseAudit = () =>
//   import("@/views/member-manage/enterprise-audit/enterprise-audit.vue");
const memberList = () => import("@/views/member-manage/member-list/member-list.vue");
const memberDetail = () => import("@/views/member-manage/member-list/children/member-detail/member-detail.vue");
// const bindCard = () =>
//   import("@/views/member-manage/member-list/children/bind-card.vue");
const chargeCard = () => import("@/views/member-manage/member-list/children/charge-card/charge-card.vue");
const refundCard = () => import("@/views/member-manage/member-list/children/refund-card/refund-card.vue");
const memberImportTable = () => import("@/views/member-manage/member-list/children/import-table/import-table.vue");
// const variationRecord = () =>
//   import("@/views/member-manage/member-list/children/variation-record.vue");
// memberMoneyRecord
const memberMoneyRecord = () => import("@/views/member-manage/member-list/children/money-record/money-record.vue");
const memberIntegralAdjustment = () => import("@/views/member-manage/member-list/children/integral-adjustment/integral-adjustment.vue");
const memberGradeAdjustment = () => import("@/views/member-manage/member-list/children/grade-adjustment/grade-adjustment.vue");
const memberBindCard = () => import("@/views/member-manage/member-list/children/bind-card/bind-card.vue");
const corporateMemberList = () => import("@/views/member-manage/corporate-member-list/corporate-member-list.vue");
const corporateMemberRecharge = () => import("@/views/member-manage/corporate-member-list/children/corporate-member-recharge/corporate-member-recharge.vue");
const corporateMemberDetail = () => import("@/views/member-manage/corporate-member-list/children/corporate-member-detail/corporate-member-detail.vue");
const moneyRecord = () => import("@/views/member-manage/corporate-member-list/children/money-record/money-record.vue");
const editCorporateMember = () => import("@/views/member-manage/corporate-member-list/children/edit-corporate-member/edit-corporate-member.vue");
const addCorporateMember = () => import("@/views/member-manage/corporate-member-list/children/add-corporate-member/add-corporate-member.vue");
// const bindSites = () =>
//   import("@/views/member-manage/corporate-member-list/children/bind-sites.vue");
const bindSites = () => import("@/views/member-manage/corporate-member-list/children/bind-sites/bind-sites.vue");
const members = () => import("@/views/member-manage/corporate-member-list/children/members/members.vue");
const membersBindCard = () => import("@/views/member-manage/corporate-member-list/children/members/children/members-bina-card.vue");
const membersHistory = () => import("@/views/member-manage/corporate-member-list/children/members/children/members-history.vue");
const membersAdd = () => import("@/views/member-manage/corporate-member-list/children/members/children/members-add.vue");
const membersCardNoList = () => import("@/views/member-manage/corporate-member-list/children/members/children/members-carNo.vue");
const membersUserGroup = () => import("@/views/member-manage/corporate-member-list/children/members-user-group/members-user-group.vue");
const membersUserGroupAdd = () => import("@/views/member-manage/corporate-member-list/children/members-user-group/children/members-user-group-add.vue");
const membersUserGroupUpdata = () => import("@/views/member-manage/corporate-member-list/children/members-user-group/children/members-user-group-updata.vue");
const membersUserGroupDetails = () => import("@/views/member-manage/corporate-member-list/children/members-user-group/children/members-user-group-details.vue");
const membersRefund = () => import("@/views/member-manage/corporate-member-list/children/refund/refund.vue");
const memberBalanceReminder = () => import("@/views/public-page/balance-reminder/balance-reminder.vue");
const oneToMorAudit = () => import("@/views/member-manage/one-to-more-audit/one-to-more-audit.vue");
const licensePlateLibrary = () => import("@/views/member-manage/license-plate-library/license-plate-library.vue");
const enterpriseApplication = () => import("@/views/member-manage/enterprise-application/enterprise-application.vue");
const enterpriseApplicationAudit = () => import("@/views/member-manage/enterprise-application/children/audit/audit.vue");
const memberCancellation = () => import("@/views/member-manage/member-cancellation/member-cancellation.vue");
const cancellationMoneyRecord = () => import("@/views/member-manage/member-cancellation/children/money-record/money-record.vue");
const routerList = [
    // {
    //   path: "/member-manage/enterprise-audit",
    //   name: "企业审核",
    //   component: enterpriseAudit
    // },
    {
        path: "/member-manage/member-list",
        name: "会员列表",
        component: memberList,
        children: [
            {
                path: "/member-manage/member-list/member-detail",
                name: "会员详情",
                component: memberDetail,
                meta: {
                    nameKey: "memberDetails",
                },
            },
            {
                path: "/member-manage/member-list/charge-card",
                name: "充值",
                component: chargeCard,
                meta: {
                    nameKey: "memberRecharge",
                },
            },
            {
                path: "/member-manage/member-list/refund-card",
                name: "退款",
                component: refundCard,
                meta: {
                    nameKey: "memberRefund",
                },
            },
            {
                path: "/member-manage/member-list/import-table",
                name: "会员导入",
                component: memberImportTable,
                meta: {
                    nameKey: "memberImport",
                },
            },
            // {
            //   path: "/member-manage/member-list/bind-card",
            //   name: "关联电卡",
            //   component: bindCard,
            //   meta: {
            //     nameKey: "memberBindCard"
            //   }
            // },
            // {
            //   path: "/member-manage/member-list/bind-card",
            //   name: "关联电卡",
            //   component: bindCard
            // },
            {
                path: "/member-manage/member-list/money-record",
                name: "资金记录",
                component: memberMoneyRecord,
                meta: {
                    nameKey: "memberRecord",
                },
            },
            {
                path: "/member-manage/member-list/integral-adjustment-record",
                name: "会员积分调整",
                component: memberIntegralAdjustment,
                meta: {
                    nameKey: "memberIntegral",
                },
            },
            {
                path: "/member-manage/member-list/grade-adjustment",
                name: "会员等级调整",
                component: memberGradeAdjustment,
                meta: {
                    nameKey: "memberGrade",
                },
            },
            {
                path: "/member-manage/member-list/membership-cycle",
                name: "会员周期",
                component: () => import("@/views/member-manage/member-list/children/membership-cycle/membership-cycle.vue"),
                meta: {
                    nameKey: "membershipCycle",
                },
            },
            {
                path: "/member-manage/member-list/bind-card",
                name: "会员关联电卡",
                component: memberBindCard,
                meta: {
                    nameKey: "memberBindCard",
                },
            },
        ],
    },
    {
        path: "/member-manage/corporate-member-list",
        name: "企业会员列表",
        component: corporateMemberList,
        children: [
            {
                path: "/member-manage/corporate-member-list/corporate-member-recharge",
                name: "企业会员充值",
                component: corporateMemberRecharge,
                meta: {
                    nameKey: "corporateMemberRecharge",
                },
            },
            {
                path: "/member-manage/corporate-member-list/corporate-member-detail",
                name: "企业会员详情",
                component: corporateMemberDetail,
                meta: {
                    nameKey: "corporateMemberDetails",
                },
            },
            {
                path: "/member-manage/corporate-member-list/money-record",
                name: "资金记录",
                component: moneyRecord,
                meta: {
                    nameKey: "corporateMemberRecord",
                },
            },
            {
                path: "/member-manage/corporate-member-list/edit-corporate-member",
                name: "编辑企业会员",
                component: editCorporateMember,
                meta: {
                    nameKey: "corporateMemberEdit",
                },
            },
            {
                path: "/member-manage/corporate-member-list/add-corporate-member",
                name: "新增企业会员",
                component: addCorporateMember,
                meta: {
                    nameKey: "corporateMemberAdd",
                },
            },
            {
                path: "/member-manage/corporate-member-list/bind-sites",
                name: "绑定站点",
                component: bindSites,
                meta: {
                    nameKey: "corporateMemberBind",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members",
                name: "成员",
                component: members,
                meta: {
                    nameKey: "corporateMemberMembers",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members/bind-card",
                name: "成员绑卡",
                component: membersBindCard,
                meta: {
                    nameKey: "membersBindCard",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members-history",
                name: "成员-历史记录",
                component: membersHistory,
                meta: {
                    nameKey: "corporateMemberHistory",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members/add",
                name: "新增成员",
                component: membersAdd,
                meta: {
                    nameKey: "membersAdd",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members/updata",
                name: "修改成员",
                component: membersAdd,
                meta: {
                    nameKey: "membersUp",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members/card",
                name: "成员车牌",
                component: membersCardNoList,
                meta: {
                    nameKey: "membersCard",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members/user-group",
                name: "企业会员用户组",
                component: membersUserGroup,
                meta: {
                    nameKey: "corporateUserGroup",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members/user-group-add",
                name: "企业会员用户组-新增",
                component: membersUserGroupAdd,
                meta: {
                    nameKey: "corporateUserGroupAdd",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members/user-group-updata",
                name: "企业会员用户组-修改",
                component: membersUserGroupUpdata,
                meta: {
                    nameKey: "corporateUserGroupUp",
                },
            },
            {
                path: "/member-manage/corporate-member-list/members/user-group-details",
                name: "企业会员用户组-详情",
                component: membersUserGroupDetails,
                meta: {
                    nameKey: "corporateUserGroupDetails",
                },
            },
            {
                path: "/member-manage/corporate-member-list/refund",
                name: "企业会员退款",
                component: membersRefund,
                meta: {
                    nameKey: "corporateRefund",
                },
            },
            {
                path: "/member-manage/corporate-member-list/balance-reminder",
                name: "企业会员余额提醒",
                component: memberBalanceReminder,
                meta: {
                    nameKey: "corporateBalance",
                },
            },
            {
                path: "/member-manage/corporate-member-list/bind-station-list",
                name: "关联站点",
                component: () => import("@/views/member-manage/corporate-member-list/children/bind-station-list/bind-station-list.vue"),
                meta: {
                    nameKey: "corporateMemberBindList",
                },
            },
            {
                path: "/member-manage/corporate-member-list/ent-pay-order",
                name: "统付订单",
                component: () => import("@/views/member-manage/corporate-member-list/children/ent-pay-order/ent-pay-order.vue"),
                meta: {
                    nameKey: "corporateMemberEntPayOrder",
                },
            },
        ],
    },
    {
        path: "/member-manage/one-to-more-audit",
        name: "一号多充审核",
        component: oneToMorAudit,
    },
    {
        path: "/member-manage/license-plate-library",
        name: "车牌库",
        component: licensePlateLibrary,
    },
    {
        path: "/member-manage/enterprise-application",
        name: "企业会员申请",
        component: enterpriseApplication,
        children: [
            {
                path: "/member-manage/enterprise-application/audit",
                name: "企业会员申请审核",
                component: enterpriseApplicationAudit,
                meta: {
                    nameKey: "enterpriseApplicationAudit",
                },
            },
        ],
    },
    {
        path: "/member-manage/cancellation",
        name: "会员注销列表",
        component: memberCancellation,
        children: [
            {
                path: "/member-manage/cancellation/money-record",
                name: "注销会员/资金记录",
                component: cancellationMoneyRecord,
                meta: {
                    nameKey: "cancellationMemberRecord",
                },
            },
        ],
    },
    {
        path: "/member-manage/member-blacklist",
        name: "黑名单",
        component: () => import("@/views/member-manage/member-blacklist/member-blacklist.vue"),
    },
];
export default routerList;
